// extracted by mini-css-extract-plugin
module.exports = {"item":"_1zgn-WlW6O6pV93CId6D7s","heading":"_1b5nEdc0GQSFjk3Kf7NKsa","summary":"_1UUesiDg3-TBpIuhayk89S","button":"_2qy1Ti5c_ys4Rhrz5t7rsK"};